
import SummaryPathSegmentView from '@/components/SummaryPathSegmentView.vue';
import { Popover } from 'bootstrap';
import { computed, ComputedRef, defineComponent } from 'vue';
import { useStore } from 'vuex';
import Navbar from './components/Navbar.vue';
import PathView from './components/PathView.vue';
import { PathSegment } from './models/path-segment';

new Popover(document.body, {
  selector: '[data-bs-toggle=\'popover\']',
  trigger: 'hover'
});

export default defineComponent({
  name: 'FuneralConfigurator',
  components: {
    SummaryPathSegmentView,
    PathView,
    Navbar
  },
  setup() {
    const store = useStore();

    const pathSegments: ComputedRef<PathSegment[]> = computed(() => {
      return store.state.pathSegments;
    });

    const selectedSegment: ComputedRef<PathSegment> = computed(() => {
      return store.state.currentPathSegment;
    });

    const currentSegments: ComputedRef<PathSegment[]> = computed(() => {
      return (selectedSegment?.value !== null)
          ? selectedSegment?.value?.children
          : pathSegments?.value;
    });

    const isSummaryActive: ComputedRef<boolean> = computed(() => {
      return store.state.summaryActive;
    });

    const footerText: ComputedRef<boolean> = computed(() => {
      return store.state.morticianSettings?.footerText ?? '';
    });

    return {
      pathSegments,
      selectedSegment,
      currentSegments,
      isSummaryActive,
      footerText
    };
  }
});
